document.addEventListener("DOMContentLoaded", async () => {
  const buttons = document.querySelectorAll(".favorite-btn");
  if (!buttons.length) return;

  let favorites = [];

  // Fetch current favorites
  async function loadFavorites() {
    const res = await fetch("/account?view=favorites-json");
    if (!res.ok) return [];
    try { return await res.json(); } catch { return []; }
  }

  // Save favorites to metafield
  async function saveFavorites(favs) {
    const query = `
      mutation updateFavorites($input: CustomerUpdateInput!) {
        customerUpdate(input: $input) {
          customer {
            id
            metafield(namespace: "custom", key: "favorites") { value }
          }
          userErrors { message }
        }
      }`;
    await fetch("/api/2024-07/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "YOUR_STOREFRONT_ACCESS_TOKEN"
      },
      body: JSON.stringify({
        query,
        variables: {
          input: {
            metafields: [
              {
                namespace: "custom",
                key: "favorites",
                type: "list.product_reference",
                value: JSON.stringify(favs.map(id => `gid://shopify/Product/${id}`))
              }
            ]
          }
        }
      })
    });
  }

  favorites = await loadFavorites();

  buttons.forEach(btn => {
    const id = parseInt(btn.dataset.productId);
    if (favorites.includes(id)) btn.classList.add("is-fav");

    btn.addEventListener("click", async () => {
      if (btn.classList.contains("disabled")) return;

      btn.classList.toggle("is-fav");
      const isFav = btn.classList.contains("is-fav");
      if (isFav) favorites.push(id);
      else favorites = favorites.filter(f => f !== id);

      await saveFavorites(favorites);
    });
  });
});
